import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  selectAllBillToLocations,
  selectAllServiceLocations,
  useLoadEntityLocationsOnMount,
} from '@user/store/entityLocations'
import { EntityLocationsPopoverContentProps } from '../typings'
import { useGetLeadOppProductsOnMount } from '@user/store/leadOppProducts/hooks/useGetLeadProductsOnMount'
import { useGetEntityAppointmentsOnMount } from '@user/store/scheduling'

export function useEntityPopoverContentData(
  params: EntityLocationsPopoverContentProps,
) {
  const { entityId, entityType, matched, updatePosition } = params

  const leadProductStatus = useGetLeadOppProductsOnMount(entityId, entityType)
  const status = useLoadEntityLocationsOnMount(entityId, entityType)
  const appointmentStatus = useGetEntityAppointmentsOnMount(
    entityId,
    entityType,
  )
  //get appointments
  const serviceLocations = useSelector(selectAllServiceLocations)
  const billToLocations = useSelector(selectAllBillToLocations)

  //use and pass slector
  const loading =
    status === 'pending' ||
    leadProductStatus === 'pending' ||
    appointmentStatus === 'pending'

  const noLocations =
    billToLocations.length === 0 || serviceLocations.length === 0

  const error = status === 'fail' || (status === 'success' && noLocations)

  const displayMatch = !matched && !loading && !error

  useEffect(() => void updatePosition(), [status, updatePosition])

  return {
    loading,
    error,
    serviceLocations,
    billToLocations,
    displayMatch,
  }
}
